module.exports = __webpack_public_path__ + "img/Slide4.da14e6be.png";